import { View, Text, Image } from "@react-pdf/renderer";
import { styles, COLORS } from "./PdfStyles";
import healthcompassLogoBw from "../images/healthcompass-logo-bw.png";
import headingImageBw from "../images/heading-image-bw.png";

/**
 * PdfPageHeader — fixed header that repeats on every PDF page.
 *
 * Layout mirrors the DOM FormHeader:
 *   LEFT col  — HC logo (top) + form title + subtitle (below)
 *   RIGHT col — pharmacy name box + detail rows
 *
 * Props:
 *   pharmacyName, pharmacyStoreNumber, pharmacyPhone, pharmacyFax, pharmacyEmail
 */
export const PdfPageHeader = ({
  pharmacyName = "",
  pharmacyStoreNumber = "",
  pharmacyPhone = "",
  pharmacyFax = "",
  pharmacyEmail = "",
}) => (
  <View style={styles.pageHeader} fixed>
    {/* Background banner image */}
    <Image
      src={headingImageBw}
      style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
    />

    {/* Two-column row: LEFT (logo + title) | RIGHT (pharmacy) */}
    <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>

      {/* LEFT: HC logo stacked above title + subtitle */}
      <View style={{ flex: 1 }}>
        <Image
          src={healthcompassLogoBw}
          style={{ width: 210, height: 38, objectFit: "contain", marginLeft: -15 }}
        />
        <Text style={[styles.formTitle, { marginTop: 4 }]}>
          Intervention Communication Form
        </Text>
        <Text style={[styles.formSubtitle, { marginTop: 2 }]}>
          Please complete and return the form to the pharmacy.
        </Text>
      </View>

      {/* RIGHT: pharmacy name box + detail rows */}
      <View style={{ alignItems: "flex-end" }}>
        <View
          style={{
            borderWidth: 1,
            borderColor: COLORS.border,
            borderRadius: 7.5,
            paddingHorizontal: 10,
            paddingVertical: 4,
            marginBottom: 3,
            minWidth: 130,
            alignItems: "center",
          }}
        >
          <Text style={styles.pharmacyNameBox}>
            {pharmacyName || "Pharmacy Name / Logo"}
          </Text>
        </View>

        <View style={{ marginTop: 4 }}>
          {[
            ["Store #", pharmacyStoreNumber],
            ["Phone Number", pharmacyPhone],
            ["Fax", pharmacyFax],
            ["Email", pharmacyEmail],
          ].map(([lbl, val]) => (
            <View key={lbl} style={{ flexDirection: "row", marginBottom: 3 }}>
              <Text style={styles.pharmacyDetailLabel}>{`${lbl} `}</Text>
              <Text style={styles.pharmacyDetailValue}>{val || ""}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  </View>
);
